import { render, staticRenderFns } from "./BeProgress.vue?vue&type=template&id=4adbb282&"
import script from "./BeProgress.vue?vue&type=script&lang=js&"
export * from "./BeProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports